// @ts-strict-ignore
import type { Module } from 'vuex'

import type { IndexState } from '../../models'

import { ResetAction } from '../common/actions/reset.action'
import { COMMON_CONSTS } from '../common/common.consts'
import { ResetMutation } from '../common/mutations/reset.mutation'
import { DiscardJobAction } from './actions/discard-job.action'
import { DownloadFeedAction } from './actions/download-feed.action'
import { GetClientAction } from './actions/get-client.action'
import { ListJobsAction } from './actions/list-jobs.action'
import { ReimportJobAction } from './actions/reimport-job.action'
import { ReindexFeedAction } from './actions/reindex-feed.action'
import { SubmitFeedAction } from './actions/submit-feed.action'
import { UpdateConfigAction } from './actions/update-config.action'
import { JobsGetter } from './getters/jobs.getter'
import { INDEX_CONSTS } from './index.consts'
import { SetClientMutation } from './mutations/set-client.mutation'
import { SetJobsMutation } from './mutations/set-jobs.mutation'

export const INDEX_MODULE: Module<IndexState, any> = {
  namespaced: true,

  initialState: (): IndexState => ({
    clients: {},
    jobs: [],
  }),
  state: (): IndexState => INDEX_MODULE.initialState(),

  getters: {
    [INDEX_CONSTS.getters.jobs]: JobsGetter.execute,
  },

  actions: {
    [INDEX_CONSTS.actions.getClient]: GetClientAction.execute,
    [INDEX_CONSTS.actions.listJobs]: ListJobsAction.execute,
    [INDEX_CONSTS.actions.submitFeed]: SubmitFeedAction.execute,
    [INDEX_CONSTS.actions.reindexFeed]: ReindexFeedAction.execute,
    [INDEX_CONSTS.actions.reimportJob]: ReimportJobAction.execute,
    [INDEX_CONSTS.actions.discardJob]: DiscardJobAction.execute,
    [INDEX_CONSTS.actions.downloadFeed]: DownloadFeedAction.execute,
    [INDEX_CONSTS.actions.updateConfig]: UpdateConfigAction.execute,
    [COMMON_CONSTS.actions.reset]: context =>
      ResetAction.execute(context, INDEX_MODULE.initialState()),
  },

  mutations: {
    [INDEX_CONSTS.mutations.setClient]: SetClientMutation.execute,
    [INDEX_CONSTS.mutations.setJobs]: SetJobsMutation.execute,
    [COMMON_CONSTS.mutations.reset]: ResetMutation.execute,
  },
}
